export default "/assets/img2.jpg";